module.exports = __webpack_public_path__ + "static/media/twitter.0dcb9b1f.svg";